/**
 * Full page navigation. Kept behind functions because jsdom cannot intercept
 * `window.location` navigation, so tests mock this module instead.
 */
export const navigateTo = (url: string): void => {
  window.location.href = url
}

/** Like `navigateTo` but does not add a history entry. */
export const replaceLocation = (url: string): void => {
  window.location.replace(url)
}

export const reloadPage = (): void => {
  window.location.reload()
}
